<template>
  <section class="app-main" :class="isNoPadding ? 'no-padding' : ''">
    <router-view v-slot="{ Component, route }">
      <!-- <StatusNofitication /> -->
      <transition name="fade-transform">
        <keep-alive :include="tagsViewStore.cachedViews">
          <component v-if="!route.meta.link" :is="Component" :key="route.path"/>
        </keep-alive>
      </transition>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup>
import { computed } from 'vue'
import iframeToggle from "./IframeToggle/index"
import useTagsViewStore from '@/store/modules/tagsView'

const tagsViewStore = useTagsViewStore()
const route = useRoute();

// 判断是否需要padding-bottom
const isNoPadding = computed(() => {
  return route.path === '/scheduleMenu/schedule' || route.path === '/index'
})
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50；移动端由 layout 的 .main-container padding-top 占位，此处不重复 margin */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-bottom: 100px;
  &.no-padding {
    padding-bottom: 0;
  }

  @media (max-width: 768px) {
    min-height: calc(100vh - var(--mobile-header-height, 72px));
  }
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 6px;
  }
}

/* 全局细滚动条：透明轨道，明暗模式分离 */
html {
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--text-secondary, #909399) 55%, transparent) transparent;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: color-mix(in srgb, var(--text-secondary, #909399) 48%, transparent);
  background-clip: padding-box;
  border: 2px solid transparent;
  border-radius: 999px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: color-mix(in srgb, var(--text-secondary, #606266) 72%, transparent);
}

html.dark {
  scrollbar-color: color-mix(in srgb, #9aa0a6 45%, transparent) transparent;
}

html.dark ::-webkit-scrollbar-thumb {
  background-color: color-mix(in srgb, #9aa0a6 40%, transparent);
}

html.dark ::-webkit-scrollbar-thumb:hover {
  background-color: color-mix(in srgb, #c0c4cc 55%, transparent);
}
</style>

